import { render, staticRenderFns } from "./ServiceTabs.vue?vue&type=template&id=094da49e&"
import script from "./ServiceTabs.vue?vue&type=script&lang=js&"
export * from "./ServiceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports